/**
 * Toggle the context drawer open/closed and select the given page.
 *
 * @param {string} page The drawer page name to display.
 */
function drawerToggle(page) {
	$('#context-drawer').toggleClass('open');
	selectPage(page);
}
/**
 * Open the context drawer and select the given page.
 *
 * @param {string} page The drawer page name to display.
 */
function drawerOpen(page) {
	$('#context-drawer').addClass('open');
	selectPage(page);
}

/**
 * Close the context drawer.
 */
function drawerClose() {
	$('#context-drawer').removeClass('open');
	selectPage();
}

/**
 * Select and display a specific drawer page.
 *
 * @param {string} page The drawer page name to display (empty to deselect all).
 */
function selectPage(page = '') {
	$('#context-drawer .drawer-page').removeClass('selected');
	if ($('#context-drawer').hasClass('open')) {
		$('#context-drawer .drawer-page[data-page="'+page+'"]').addClass('selected');
	}
}

/**
 * Toggle the processing state of the context drawer.
 *
 * When active, pointer events are disabled and a loading overlay
 * is displayed to prevent user interaction during AJAX requests.
 *
 * @param {boolean} state - True to enable processing, false to disable.
 */
function setDrawerProcessing(state) {
	$('#context-drawer').toggleClass('processing', state);
}